import has from 'lodash/has';
import { computeUserFootprint } from './computeResults';
import patch from './patch';

/**
 * Save fuel type of a vehicle. Note that electric vehicle miles are set to
 * 0 for electic cars in selectors.params.computeFootprint.
 * @param {Object} vehicle See selectors/index.js#vehicles
 * @param {Object} opts
 * @param {Boolean} opts.isElectric
 * @param {Number} opts.fuelType 1 for gasoline, 2 for diesel.
 */
export default (vehicle, { fuelType, isElectric }) => (dispatch, getState) => {
  const state = getState();
  const params = {
    [`input_footprint_transportation_fuel${vehicle.index}`]: isElectric ? 1 : fuelType,
  };
  if (isElectric) {
    dispatch(patch({
      user_footprint: { electricVehicles: { [vehicle.index]: true } },
    }));
  } else if (has(state.user_footprint, ['electricVehicles', `${vehicle.index}`])) {
    const electricVehicles = {
      ...state.user_footprint.electricVehicles,
      [`${vehicle.index}`]: undefined,
    };
    dispatch(patch({
      user_footprint: { electricVehicles },
    }));
  }
  computeUserFootprint(params)(dispatch, getState);
};
